import React from 'react'
import AsyncWindow2 from 'components/Functional/AsyncWindow2.jsx'

export const addAsyncComponent = (config, context = null) => {
  const newConfig = { ...config }
  let loader = newConfig.loader
  // in some cases there are two different window components for two different contexts that
  // have the same id, this allows each context to have its own loader to load different files.
  // its not prefered for future dev but it supports existing windows.
  if (context != null) {
    const foundContext = newConfig.contexts.find(
      config => config.context === context
    )
    if (foundContext?.loader) {
      loader = foundContext.loader
    }
  }
  newConfig.component = AsyncWindow2(React.lazy(loader))
  return newConfig
}

// window config precedence order is:
// windowConfig generated in sysAdmin is highest priority
// context specific windowConfig below is second highest priority
// window specific windowConfig below is lowest priority

export const allWindows = [
  {
    id: 'userDetails', // (required)
    windowConfig: {
      // (optional)
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
      // test: true // example hard coded config option passed into window
    },
    screenTypes: ['standard', 'ipad'],
    isConfigureable: false, // default (true) should the window show in sysAdmin screens/windows area.
    contexts: [
      // required
      {
        context: 'adminDisplay', // (required)
        requiredPrivileges: [], // (required)
        // privilegeOperator (optional): //'or'(default) || 'and'
        // windowConfig (optional): {
        //   test2: true
        // }
        // closeable (optional): true (default),
        // draggable (optional): true (default),
        // resizeable (optional): true (default),
        // singleRxWindow (optional): false (default) single rx windows
        //                            show the rx the data pertains to in the title
        canFavorite: false // (optional) default true
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: [],
        canFavorite: false
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: [],
        canFavorite: false
      },
      {
        context: 'configDisplay',
        requiredPrivileges: [],
        canFavorite: false
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/UserDetailsWindow/UserDetailsWindow.jsx'
      ) // required
  },
  {
    id: 'accessAuditLog', // (required)
    windowConfig: {
      // (optional)
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
      // test: true // example hard coded config option passed into window
    },
    screenTypes: [
      // (required)
      'standard'
    ],
    contexts: [
      // required
      {
        context: 'adminDisplay', // (required)
        requiredPrivileges: ['view_access_audit_log'], // (required)
        // privilegeOperator (optional): //'or'(default) || 'and'
        // windowConfig (optional): {
        //   test2: true
        // }
        // closeable (optional): true (default),
        // draggable (optional): true (default),
        // resizeable (optional): true (default),
        // singleRxWindow (optional): false (default) single rx windows
        //                            show the rx the data pertains to in the title
        canFavorite: false // (optional) default true
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/AccessAuditLog/AccessAuditLogWindow.jsx'
      ) // required
  },
  {
    id: 'userMessages',
    screenTypes: ['standard', 'ipad'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    isConfigureable: false,
    contexts: [
      // required
      {
        context: 'adminDisplay',
        requiredPrivileges: [],
        canFavorite: false
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: [],
        canFavorite: false
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: [],
        canFavorite: false
      },
      {
        context: 'configDisplay',
        requiredPrivileges: [],
        canFavorite: false
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/UserMessageWindow/UserMessageWindow.jsx'
      )
  },
  {
    id: 'staticContent1',
    screenTypes: ['standard'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/StaticContentWindow/StaticContentWindow.jsx'
      )
  },
  {
    id: 'staticContent2',
    screenTypes: ['standard'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/StaticContentWindow/StaticContentWindow.jsx'
      )
  },
  {
    id: 'staticContent3',
    screenTypes: ['standard'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/StaticContentWindow/StaticContentWindow.jsx'
      )
  },
  {
    id: 'staticContent4',
    screenTypes: ['standard'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/StaticContentWindow/StaticContentWindow.jsx'
      )
  },
  {
    id: 'staticContent5',
    screenTypes: ['standard'],
    windowConfig: {
      width: '96%',
      height: '90%',
      x: '2%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'nurseDashboard',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/StaticContentWindow/StaticContentWindow.jsx'
      )
  },
  {
    id: 'skinTestAntigens',
    screenTypes: ['standard', 'ipad'],
    defaultWindowConfig: {
      title: 'Skin Test Antigens',
      width: '75%',
      height: '85%',
      x: '12%',
      y: '2%'
    },
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/SkinTestAntigensWindow/SkinTestAntigensWindow.jsx'
      )
  },
  {
    id: 'skinTestDetail',
    screenTypes: ['standard', 'ipad'],
    defaultWindowConfig: {
      title: 'Skin Test Details',
      width: '75%',
      height: '85%',
      x: '12%',
      y: '2%'
    },
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: []
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: []
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/SkinTestDetailWindow/SkinTestDetailWindow.jsx'
      )
  },
  {
    id: 'visitHistory',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['view_visit_history']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/VisitHistoryWindow/VisitHistoryWindow.jsx'
      )
  },
  {
    id: 'prescriptionPanels',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['prescription_panels_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/PrescriptionPanelsWindow/PrescriptionPanelsWindow.jsx'
      )
  },
  {
    id: 'apiLog',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['view_api_log']
      }
    ],
    loader: () =>
      import('components/AdminDisplay/Windows/ApiLogWindow/ApiLogWindow.jsx')
  },
  {
    id: 'clickLog',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['view_click_log']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/ClickLogWindow/ClickLogWindow.jsx'
      )
  },
  {
    id: 'entDilutions',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['ent_dilution_type_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/EntDilutionsWindow/EntDilutionsWindow.jsx'
      )
  },
  {
    id: 'clinic',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['clinic_read']
      }
    ],
    loader: () =>
      import('components/AdminDisplay/Windows/ClinicWindow/ClinicWindow.jsx')
  },
  {
    id: 'protocols',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['st_protocol_read', 'sys_admin'],
        privilegeOperator: 'and'
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/ProtocolsWindow/ProtocolsWindow.jsx'
      )
  },
  {
    id: 'panels',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['st_panels_read']
      }
    ],
    loader: () =>
      import('components/AdminDisplay/Windows/PanelsWindow/PanelsWindow.jsx')
  },
  {
    id: 'extracts',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['extract_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/ExtractsWindow/ExtractsWindow.jsx'
      )
  },
  {
    id: 'profiles',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['profile_read']
      }
    ],
    loader: () =>
      import('components/AdminDisplay/Windows/ProfileWindow/ProfileWindow.jsx')
  },
  {
    id: 'pharmacyProfiles',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['pharmacy_profile_view']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/PharmacyProfilesWindow/PharmacyProfilesWindow.jsx'
      )
  },
  {
    id: 'pharmacyExtracts',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['pharmacy_extract_view']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/PharmacyExtractsWindow/PharmacyExtractsWindow.jsx'
      )
  },
  // {
  //   id: 'backups',
  // screenTypes: [
  //   'standard'
  // ],
  //   contexts: [
  //     {
  //       context: 'adminDisplay',
  //       requiredPrivileges: ['database_backups_read']
  //     }
  //   ],
  //   loader: () => import('components/AdminDisplay/Windows/BackupsWindow/BackupsWindow.jsx')
  // },
  {
    id: 'inventory',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['inventory_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/InventoryWindow/InventoryWindow.jsx'
      )
  },
  {
    id: 'patientFlags',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['patient_flag_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/PatientFlagsWindow/PatientFlagsWindow.jsx'
      )
  },
  {
    id: 'userManagement',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['all_user_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/UserManagementWindow/UserManagementWindow.jsx'
      )
  },
  {
    id: 'treatmentPlan',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['treatment_plan_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/TreatmentPlanWindow/TreatmentPlanContainer.jsx'
      )
  },
  {
    id: 'accountManagement',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['account_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/AccountManagementWindow/AccountManagementWindow.jsx'
      )
  },
  {
    id: 'questions',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['question_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/QuestionWindow/QuestionContainer.jsx'
      )
  },
  {
    id: 'questionnaire',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['questionnaire_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/QuestionnaireWindow/QuestionnaireContainer.jsx'
      )
  },
  // {
  //   contexts: [
  //     {
  //       context: 'adminDisplay',
  //       configurable: true,
  //       mandatory: false,
  //       requiredPrivileges: ['message_read']
  //     }
  //   ]
  //   id: 'messaging',
  // screenTypes: [
  //   'standard'
  // ],
  //   loader: () => import('components/AdminDisplay/Windows/MessagingWindow/MessagingWindow.jsx')
  // },
  {
    id: 'provider',
    windowConfig: {
      'showCalculator': false //set default option for show calculator
    },
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['provider_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/ProviderWindow/ProviderWindow.jsx'
      )
  },
  {
    id: 'scanExternalBarcode',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['inventory_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vials_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/ExternalBarcodeWindow/ExternalBarcodeWindow.jsx'
      )
  },
  {
    id: 'vialsList',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['vials_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vials_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/VialsListWindow/VialsListWindow.jsx'
      )
  },
  {
    id: 'injections',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['inj_history_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['inj_history_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/InjectionListWindow/InjectionListWindow.jsx'
      )
  },
  {
    id: 'patientsList',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['patient_list_read']
      }
    ],
    loader: () =>
      import(
        'components/AdminDisplay/Windows/PatientsListWindow/PatientsListWindow.jsx'
      )
  },
  {
    id: 'treatmentSets',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'adminDisplay',
        requiredPrivileges: ['treatment_set_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['treatment_set_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/TreatmentSetWindow/TreatmentSetWindow.jsx'
      )
  },
  {
    id: 'purchaseOrders',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['pt_purchase_order_read'],
        loader: () =>
          import(
            'components/Dashboard/Windows/PurchaseOrdersWindow/PurchaseOrdersWindow.jsx'
          )
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['pt_purchase_order_read'],
        loader: () =>
          import(
            'components/PatientDisplay/Windows/PurchaseOrdersWindow/PurchaseOrdersWindow.jsx'
          )
      }
    ]
  },
  {
    id: 'skinTestList',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['st_list_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['st_pt_list_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/SkinTestListWindow/SkinTestListWindow.jsx'
      )
  },
  {
    id: 'vialTestList',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['vial_test_list_read']
      },
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vial_test_list_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/VialTestListWindow/VialTestListWindow.jsx'
      )
  },
  {
    id: 'injection',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['waiting_for_inj_read']
      }
    ],
    loader: () =>
      import('components/Dashboard/Windows/WaitingInjectionWindow.jsx')
  },
  {
    id: 'excuse',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['waiting_to_excuse_read']
      }
    ],
    loader: () => import('components/Dashboard/Windows/WaitingExcuseWindow.jsx')
  },
  {
    id: 'roomed',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['roomed_read']
      }
    ],
    loader: () =>
      import('components/Dashboard/Windows/WithInjectionStaffWindow.jsx')
  },
  {
    id: 'mixingQueue',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'nurseDashboard',
        requiredPrivileges: ['mixing_queue_read']
      }
    ],
    loader: () =>
      import(
        'components/MultiContext/Windows/MixingQueueWindow/MixingQueueWindow.jsx'
      )
  },
  {
    id: 'vialTestScoring',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vial_test_scoring_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/VialTestScoringWindow/VialTestScoringWindow.jsx'
      )
  },
  {
    id: 'skinTestHistory',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['st_history_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/SkinTestHistoryWindow/SkinTestHistoryWindow.jsx'
      )
  },
  {
    id: 'reportHistory',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['report_history_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/ReportHistoryWindow/ReportHistoryWindow.jsx'
      )
  },
  {
    id: 'orderEntry',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['order_entry_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/OrderEntryWindow/OrderEntryWindow.jsx'
      )
  },
  {
    id: 'directMessageWindow',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['direct_message_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/DirectMessageWindow/DirectMessageWindow.jsx'
      )
  },
  {
    id: 'immunotherapySummary',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['immunotherapy_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/ImmunotherapySummaryWindow/ImmunotherapySummaryWindow.jsx'
      ),
    modalConfig: { cover: false }
  },
  {
    id: 'questionnaireHistory',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['pt_questionnaire_history_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/QuestionnaireHistoryWindow/QuestionnaireHistoryWindow.jsx'
      )
  },
  {
    id: 'questionnaireReview',
    screenTypes: ['standard','ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['pt_questionnaire_review_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/QuestionnaireReviewWindow/QuestionnaireReviewWindow.jsx'
      )
  },
  {
    id: 'standardInjection',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['injection_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/StandardInjectionWindow/StandardInjectionWindow.jsx'
      )
  },
  {
    id: 'attachments',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['attachment_read_all']
      }
    ],
    loader: () => import('components/PatientDisplay/Windows/AttachmentsWindow/AttachmentsWindow.jsx')
  },
  {
    id: 'expressInjection',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['injection_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/StandardInjectionWindow/StandardInjectionWindow.jsx'
      )
  },
  {
    id: 'nonXISInjections',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['manual_inj_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/NonXISInjectionsWindow/NonXISInjectionsWindow.jsx'
      )
  },
  {
    id: 'injectionAdjust',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['inj_adjust_read'],
        singleRxWindow: true
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/InjAdjustWindow/InjAdjustWindow.jsx'
      ),
    modalConfig: { cover: false }
  },
  {
    id: 'injectionGraph',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['inj_graph_read'],
        singleRxWindow: true
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/InjectionGraphWindow/InjectionGraphWindow.jsx'
      ),
    modalConfig: { cover: false }
  },
  {
    id: 'questionnaires',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['pt_questionnaire_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/QuestionnaireWindow/QuestionnaireWindow.jsx'
      )
  },
  {
    id: 'activateVials',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['activate_vials_read'],
        singleRxWindow: true
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/ActivateVialsWindow/ActivateVialsWindow.jsx'
      ),
    modalConfig: { cover: true }
  },
  {
    id: 'prescriptions',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['allergy_rx_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/PrescriptionsWindow/PrescriptionsWindow.jsx'
      ),
    modalConfig: { cover: 0.9 }
  },
  {
    id: 'updatePatient',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['patient_details_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/UpdatePatientWindow/UpdatePatientWindow.jsx'
      )
  },
  {
    id: 'patientNotes',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['patient_notes_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/PatientNoteWindow/PatientNoteWindow.jsx'
      ),
    modalConfig: { cover: false }
  },
  {
    id: 'vialMixing',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vial_mixing_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/VialMixingWindow/VialMixingWindow.jsx'
      )
  },
  {
    id: 'singleScreenMix',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['vial_mixing_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/SingleScreenMixWindow/SingleScreenMixWindow.jsx'
      )
  },
  {
    id: 'tracking',
    screenTypes: ['standard'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['tracking_read']
      }
    ],
    loader: () =>
      import(
        'components/PatientDisplay/Windows/TrackingWindow/TrackingWindow.jsx'
      ),
    modalConfig: { cover: false }
  },
  {
    id: 'wrapup',
    screenTypes: ['standard', 'ipad'],
    contexts: [
      {
        context: 'patientDisplay',
        requiredPrivileges: ['pt_wrapup_read']
      }
    ],
    loader: () =>
      import('components/PatientDisplay/Windows/WrapupWindow/WrapupWindow.jsx')
  }
]
